module.exports = __webpack_public_path__ + "static/im-still-here-613764b48d1c9e771c3a5c86a3f76f62.jpg";